import React from 'react';

import { Box, useMantineTheme } from '@mantine/core';
import { IconBarbell } from '@tabler/icons-react';

interface WorkoutStatusIconProps {
  hasLoggedResults?: boolean;
}

const WorkoutStatusIcon = ({ hasLoggedResults = false }: WorkoutStatusIconProps): JSX.Element => {
  const theme = useMantineTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 30,
        height: 30,
        borderRadius: theme.radius.sm,
        backgroundColor: hasLoggedResults ? theme.colors.green[0] : theme.white,
        border: hasLoggedResults ? 'none' : `1.5px solid ${theme.colors.gray[3]}`,
        flexShrink: 0,
      }}
    >
      <IconBarbell
        size={18}
        color={hasLoggedResults ? theme.colors.green[7] : theme.colors.gray[5]}
        style={{ transform: 'rotate(45deg)' }}
      />
    </Box>
  );
};

export default WorkoutStatusIcon;
